module.exports = __webpack_public_path__ + "img/base_divers_favoris.3bdb392e.svg";